const initialState={
  online: false,
  authenticated: false,
  coffees: 0,
  prefs: null,
  charges:{
    totalAmount: 0,
    totalNumber: 0
  },
  user: {}
}
//reducers
export function onlineReducer(state=initialState, action){
  switch(action.type){
    case 'ONLINE':
      ///this state update needs to be immutable
      //but booleans mean nothing to immutable
      return {
        online: true
      };
    case 'OFFLINE':
      return {
        online: false
      };
    default:
      return state;
  }

}
export function errorReducer(state=initialState, action){
  switch(action.type){
    case 'ERROR':
    return{
      error: action.payload.message,
      errorStatus: action.payload.status
    };
    default:
      return state;
  }
}
////TODO: make a coffee reducer
export function coffeeReducer(state=initialState, action){
  switch(action.type){
    case 'DRINK':
            return Object.assign({}, state, {
                coffees : Number(state.coffees) +1
            });
    case 'SYNC':
      return Object.assign({}, state, {
                coffees : action.payload.amount
            });

    default:
      return state;
  }
}
export function authReducer(state=initialState, action){
  switch(action.type){
    case 'UNAUTHENTICATED':
      ///this state update needs to be immutable
      //but booleans mean nothing to immutable
      return {
        authenticated: false
      };
    case 'AUTHENTICATED':

        return Object.assign({}, state, {
                authenticated : true,
                logoutRequest: false
            });

    case 'LOGIN':
          return Object.assign({}, state, {
                loginRequestEmail : action.payload.email,
                loginRequestPW: action.payload.password,
                loginRequestStatus: action.payload.status
            });

    case 'LOGOUT':
      return Object.assign({}, state, {
                logoutRequest : true
            });
    case 'REGISTER':
      return Object.assign({}, state, {
                registerRequestEmail : action.payload.email,
                registerRequestPW: action.payload.password,
                registerRequestStatus: action.payload.status
            });
    case 'USER':
      return Object.assign({}, state, {
                user : action.payload.user,
                status: action.payload.status
            });
    case 'PROFILE':
      ///should this actually go in the user object?
      return Object.assign({}, state, {
                displayName : action.payload.displayName,
                userName: action.payload.userName
            });
    case 'PREFS':
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }

}

export function ecommReducer(state=initialState, action){
  switch(action.type){
    case 'DONATE':
      return Object.assign({}, state, {
        donation: action.payload.amount,
        completed: action.payload.completed
      });
      case 'CARD':
        return Object.assign({}, state, {
          card: action.payload.card,
          submitted: action.payload.submitted || false
        });
      case 'DELETECARD':
        return Object.assign({}, state, action.payload);
      case 'CHARGES':
        return Object.assign({}, state, {
          charges: action.payload
        });
      default:
        return state;
  }
}

export function uploadReducer(state=initialState, action){
  switch(action.type){
    case 'UPLOAD':
      return Object.assign({}, state, {
        file: action.payload.file,
        status: action.payload.status
      });
    case 'UPLOADPROGRESS':
      return Object.assign({}, state, {
        progress: action.payload.progress
      });
      default:
        return state;
  }
}

export function statsReducer(state=initialState, action){
  switch(action.type){
    case 'STATS':
      return Object.assign({}, state, {
        coffeeTotal: 0,
        coffeesThisHour: 0,
        memberTotal: 0,
        membersThisHour: 0
      });
      default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/reducers/reducers.js